import { combineActions, handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import { updateStoryApiRequest } from 'store/entities/feed/actions'
// @ts-ignore
import { cloneProTrack, getProTrackOrganizationUsersEmails } from 'store/entities/protracks/actions'
// @ts-ignore
import { postOrganizationChildren } from 'store/entities/organizationSettings/actions'
import { deleteImageFromGallery } from 'store/entities/gallery/actions'

import { modal } from './actions'

import { IModalStateRecord } from './interface'
import { setCustomStory } from '../identity/actions'
import { unsubscribeProgress } from 'store/entities/identity/actions'

export const initialState = fromJS({
  isOpen: false,
  closeTimeoutMS: 400,
  contentLabel: 'Modal',
  children: null,
  restProps: {},
})

const handleModalShow = (state: IModalStateRecord, { payload: { children, restProps } }: any) => {
  return state.set('isOpen', true).set('children', children).set('restProps', restProps)
}

const handleModalHide = (state: IModalStateRecord) => {
  return state.set('isOpen', false)
}

const handleUpdateStoryApiRequestSuccess = (state: IModalStateRecord) => {
  return state.set('isOpen', false)
}

export default handleActions(
  {
    [modal.show]: handleModalShow,
    [combineActions(
      modal.hide,
      cloneProTrack.success,
      postOrganizationChildren.success,
      deleteImageFromGallery.success,
      setCustomStory.success,
      getProTrackOrganizationUsersEmails.fail,
      unsubscribeProgress.success
    ) as any]: handleModalHide,
    [updateStoryApiRequest.success as any]: handleUpdateStoryApiRequestSuccess,
  },
  initialState as any
)
